import { type ValidationError } from '@adv-frontend/form-kit';
import { type ClientFormValidationErrorCode } from './type';

export const CLIENT_FORM_ID = 'client-form';

export const buildErrorMessage = (errors: ValidationError<ClientFormValidationErrorCode>[]): string | undefined => {
    const [validationError] = errors;

    switch (validationError?.code) {
        case 'REQUIRED_FIELD':
            return 'Обязательное поле';

        case 'INVALID_FIRST_NAME_FORMAT':
            return 'Неверный формат имени, разрешены только буквы';

        case 'INVALID_LAST_NAME_FORMAT':
            return 'Неверный формат фамилии, разрешены только буквы';

        case 'INVALID_PHONE_FORMAT':
            return 'Неверный формат телефона';

        case 'INVALID_EMAIL_FORMAT':
            return 'Неверный формат email';

        default:
            return undefined;
    }
};
